import React from 'react'
import VisibleComponent from '../../shared/VisibleComponent'

const Presentation = () => {
  return (
    <VisibleComponent>
      <div className="elements-group">
        <VisibleComponent className="centre">
          <h2 id="presentation">Présentation</h2>
          <p>
            ESPERLUETA n’est autre que la traduction en occitan auvergnat du mot
            « esperluette », le signe que voici : &. Il est à l’image de ce
            festival, qui se veut comme un tisseur de liens au sein du réseau
            associatif et étudiant clermontois. Ainsi, cette cinquième édition
            sera l’occasion pour nous Brayaudes & Brayauds de travailler en
            compagnie de{' '}
            <a target="_blank" href="https://www.lieutopie-clermont.org/">
              LieU’topie
            </a>
            ,{' '}
            <a
              target="_blank"
              href="https://www.helloasso.com/associations/clermont-folk"
            >
              Clermont Folk
            </a>{' '}
            et l’
            <a
              target="_blank"
              href="https://www.france-palestine.org/+-AFPS-Clermont-Ferrand-+"
            >
              Association France Palestine Solidarité 63
            </a>
            . Cette année, nous vous avons concocté un riche programme célébrant
            la diversité culturelle à l’œuvre dans la capitale auvergnate.
            Ainsi, les cultures populaires turque, palestinienne, auvergnate et
            même brésilienne se côtoieront pour donner à voir de multiples
            facettes de ces patrimoines culturels en mouvement (musique & danse
            bien sûr, mais aussi gastronomie, histoire, cinéma…) ! Venez
            nombreux et nombreuses !
          </p>
        </VisibleComponent>
      </div>
    </VisibleComponent>
  )
}

export default Presentation
